/* Audit: equalise testimonial card heights inside the Flickity carousel */
(function () {
  var applied = new WeakMap();
  function equalise() {
    document.querySelectorAll('.testimonials').forEach(function (wrap) {
      var vp = wrap.querySelector('.flickity-viewport');
      var cards = wrap.querySelectorAll('.flickity-slider .testimonial');
      if (!vp || cards.length < 2) return;
      var max = 0;
      cards.forEach(function (c) {
        var inner = c.querySelector('.testimonial__content') || c;
        var cs = getComputedStyle(c);
        var h = inner.scrollHeight + (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0) + (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
        if (h > max) max = h;
      });
      max = Math.ceil(max);
      if (max < 40) return;
      if (applied.get(wrap) === max && vp.style.height === max + 'px') return;
      applied.set(wrap, max);
      cards.forEach(function (c) { c.style.minHeight = max + 'px'; });
      vp.style.height = max + 'px';
    });
  }
  var t;
  function schedule(delay) { clearTimeout(t); t = setTimeout(equalise, delay || 120); }
  function observe() {
    document.querySelectorAll('.testimonials').forEach(function (wrap) {
      if (wrap.dataset.dmEqObserved) return;
      wrap.dataset.dmEqObserved = '1';
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () { schedule(60); });
        wrap.querySelectorAll('.testimonial__content').forEach(function (el) { ro.observe(el); });
        ro.observe(wrap);
      }
      if ('MutationObserver' in window) {
        new MutationObserver(function () { schedule(150); }).observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { schedule(50); setTimeout(equalise, 900); } });
        }, { threshold: 0.05 }).observe(wrap);
      }
    });
  }
  function boot() {
    observe();
    schedule(50);
    [500, 1200, 2500, 5000].forEach(function (d) { setTimeout(equalise, d); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { schedule(100); });
  window.addEventListener('resize', function () { schedule(350); });
  document.addEventListener('shopify:section:load', function () { observe(); schedule(300); setTimeout(equalise, 1500); });
  document.addEventListener('shopify:block:select', function () { schedule(300); });
  window.__dmEqualiseTestimonials = equalise;
})();

/* Audit: hide footer rows that render empty */
(function () {
  function hideEmptyFooterRows() {
    var rows = document.querySelectorAll('.site-footer-wrapper .site-footer__row');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      // No element children and no visible text — the CSS :has() rule covers
      // this too; this is the fallback for browsers without :has() support.
      if (!r.children.length && !r.textContent.trim()) r.style.display = 'none';
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyFooterRows);
  } else {
    hideEmptyFooterRows();
  }
  document.addEventListener('shopify:section:load', hideEmptyFooterRows);
})();

/* Audit: normalise ALL-CAPS footer menu labels */
(function () {
  // text-transform:capitalize only uppercases the first letter of each word — it
  // never lowercases anything, so TUNING / GUIDES / CONTACT would have stayed in
  // caps. Lowercasing those entries lets the CSS rule produce Title Case. Only
  // labels that are entirely uppercase are touched; mixed-case ones are left for
  // the CSS to handle.
  function normaliseFooterMenuCase() {
    var links = document.querySelectorAll('.site-footer-wrapper .site-footer-block-menu .navmenu-link');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      var t = el.textContent.trim();
      if (!t) continue;
      if (t === t.toUpperCase() && t !== t.toLowerCase()) {
        el.textContent = t.toLowerCase();
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normaliseFooterMenuCase);
  } else {
    normaliseFooterMenuCase();
  }
  document.addEventListener('shopify:section:load', normaliseFooterMenuCase);
})();
